<template>
  <div>
    <v-sheet class="py-6 py-md-8 px-3" color="primary">
      <TitleWidget :small="xsOnly" dark>
        {{ title }}
      </TitleWidget>
    </v-sheet>

    <v-sheet
      class="pt-6 pt-md-8 pb-10 pb-md-13 pb-lg-16 px-3 mx-auto"
      max-width="600px"
    >
      <WorkWithUsForm v-bind="form" />
    </v-sheet>
  </div>
</template>

<script>
import TitleWidget from "../components/widgets/TitleWidget.vue";
import WorkWithUsForm from "../components/forms/WorkWithUsForm.vue";

const _form = {
  action: "/rest/email/work-with-us",
  responseTo: "/trabalhe-conosco/obrigado",
};

const _data = {
  title: "Trabalhe Conosco",
  form: _form,
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  components: {
    TitleWidget,
    WorkWithUsForm,
  },
};
</script>
